import { Star, Quote } from "lucide-react";
import { SectionHeading } from "./motionPrimitives";

const TESTIMONIALS = [
    {
        quote:
            "SMART NET rebuilt our entire acquisition engine. Six months in, our cost per qualified lead is down 41% and organic traffic has tripled.",
        name: "Dana Whitmore",
        role: "COO, Novaetrics",
    },
    {
        quote:
            "The AI agent they wired into our CRM answers inbound in seconds. Our sales team only talks to leads that are ready to buy.",
        name: "Marcus Bell",
        role: "VP Sales, Velo Freight",
    },
    {
        quote:
            "Finally an agency that reports on revenue, not vanity metrics. The monthly review is the highlight of our board meetings.",
        name: "Priya Raghavan",
        role: "Founder, Pierpoint Capital",
    },
    {
        quote:
            "Our clinic's appointment requests doubled within a quarter of the local SEO overhaul. Zero guesswork, pure execution.",
        name: "Dr. Elena Sousa",
        role: "Director, Bayside Dental Group",
    },
    {
        quote:
            "They automated half of our follow-up workflows with AI. It felt like hiring three coordinators overnight.",
        name: "Tomás Herrera",
        role: "GM, Bright Harbor Realty",
    },
    {
        quote:
            "From keyword strategy to ad creative, everything runs through one tight playbook. Best marketing decision we've made.",
        name: "Alicia Grant",
        role: "CMO, Solstice Wellness",
    },
];

const Card = ({ t }) => (
    <figure className="w-[340px] sm:w-[400px] shrink-0 bg-white/5 border border-white/10 rounded-2xl p-7 hover:border-gold/50 transition-colors duration-300">
        <div className="flex items-center justify-between">
            <div className="flex gap-1">
                {[...Array(5)].map((_, i) => (
                    <Star key={i} size={15} className="fill-gold text-gold" />
                ))}
            </div>
            <Quote size={22} className="text-gold/40" />
        </div>
        <blockquote className="mt-5 text-sm text-mist leading-relaxed">
            "{t.quote}"
        </blockquote>
        <figcaption className="mt-6 flex items-center gap-3">
            <span className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-gold/15 font-display font-bold text-gold text-sm">
                {t.name.charAt(0)}
            </span>
            <div>
                <p className="text-sm font-semibold text-white">{t.name}</p>
                <p className="font-mono text-[11px] uppercase tracking-wider text-gold/80">
                    {t.role}
                </p>
            </div>
        </figcaption>
    </figure>
);

export default function Testimonials() {
    return (
        <section
            id="testimonials"
            data-testid="testimonials-section-container"
            className="bg-navy py-20 lg:py-28 overflow-hidden"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
                    <SectionHeading
                        dark
                        eyebrow="Testimonials"
                        title="Real clients. Real results."
                    />
                    <p className="max-w-sm text-mist leading-relaxed">
                        Placeholder testimonials shown for layout — swap in your
                        verified client quotes when ready.
                    </p>
                </div>
            </div>

            <div className="marquee-wrap mt-14 space-y-5">
                <div className="overflow-hidden">
                    <div className="animate-marquee-slow flex w-max gap-5 px-4">
                        {TESTIMONIALS.slice(0, 3).map((t) => (
                            <Card key={t.name} t={t} />
                        ))}
                        {TESTIMONIALS.slice(0, 3).map((t) => (
                            <Card key={`${t.name}-dup`} t={t} />
                        ))}
                    </div>
                </div>
                <div className="overflow-hidden">
                    <div className="animate-marquee-reverse flex w-max gap-5 px-4">
                        {TESTIMONIALS.slice(3).map((t) => (
                            <Card key={t.name} t={t} />
                        ))}
                        {TESTIMONIALS.slice(3).map((t) => (
                            <Card key={`${t.name}-dup`} t={t} />
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
